<template>
  <div id="findPwd" class="body-container">
    <div class="body-content">
      <div class="account-wrapper">
        <div v-if="stepBinding" class="slogan-wrapper">
<!--          <img src="/static/images/logo_index.png" alt="">-->
          <i class="icon-starry-meeting"></i>
          <span class="slogan-text">{{$t('findPwd.account_info')}}</span>
          <span class="slogan-text-small">{{$t('findPwd.current_account')}}</span>
        </div>
        <div v-if="stepSettingNewPwd" class="slogan-wrapper">
<!--          <img src="/static/images/logo_index.png" alt="">-->
          <i class="icon-starry-meeting"></i>
          <span class="slogan-text">{{$t('findPwd.change_password')}}</span>
          <span class="slogan-text-small">{{$t('findPwd.password_set')}}</span>
        </div>
        <div v-if="!stepSettingNewPwd && !stepBinding" class="slogan-wrapper">
<!--          <img src="/static/images/logo_index.png" alt="">-->
          <i class="icon-starry-meeting"></i>
          <span class="slogan-text">{{ $t('findPwd.find') }}</span>
          <span class="slogan-text-small">{{$t('findPwd.phone_find')}}</span>
        </div>

        <div v-if="stepAccount" class="account-form">
          <div class="form-row">
            <input class="form-input" type="text" name="name" v-model="account" @input="accountChange()" :placeholder="$t('findPwd.userName')">
            <p class="text-error">{{ $t(accountError) }}</p>
          </div>

          <div class="form-row">
            <input class="form-input code-input" type="text" name="code" maxlength="4" v-model="imgCode" @input="imgCodeChange()" :placeholder="$t('findPwd.code')" autocomplete="off" @keyup.enter="accountStepOne">
            <img :src="imgUrl" class="send-code-btn" alt="code" @click="findImg">
            <p class="text-error">{{ $t(imgCodeError) }}</p>
          </div>

          <div class="form-row">
            <button class="save-phone-btn" :class="{'disable': disableAccount}" @click="accountStepOne">{{ $t('findPwd.next') }}</button>
          </div>
        </div>

        <div v-if="stepCode" class="account-form">
          <div class="form-row">
            <input class="form-input" type="text" name="name" :placeholder="encryptedAccount" readonly="readonly">
          </div>
          <div class="form-row code-row">
            <input class="form-input code-input" type="text" name="code" maxlength="6" v-model="code" @input="codeChange()" :placeholder="$t('findPwd.code')" @keyup.enter="checkCode">
            <button type="button" @click="sendCode" v-bind:class="{ 'sendBtn': sendBtn, 'disabled': disabled}" v-bind:disabled="disabled">{{timeText}}{{ $t(valueText) }}</button>
            <p class="text-error">{{ $t(codeError) }}</p>
          </div>

          <div class="form-row">
            <button class="save-phone-btn" :class="{'disable': disableStepCode}" @click="checkCode">{{ $t('findPwd.next') }}</button>
          </div>
        </div>

        <div v-if="stepBinding" class="account-form binding-form">
          <div v-if="accountList.length" class="binding-content" :class="{lang: otherLanguage}">
            <div v-for="(item, index) in accountList" :key="index" class="binding-item" :class="{lang: otherLanguage}">
              <img class="binding-icon" src="../assets/images/phone.png" alt="">
              <span class="account-text">{{item}}</span>
              <span>{{phone}}</span>
              <div @click="selectAccount(item)" class="binding-button" :class="{lang: otherLanguage}">{{$t('findPwd.change_password')}}</div>
            </div>
          </div>
          <div v-else>{{$t('findPwd.not_bind_starryHub')}}</div>
        </div>

        <div v-if="stepSettingNewPwd" class="account-form">
          <div class="form-row">
            <input class="form-input" type="password" name="password" v-model="pwd" @input="newPasswordChange()" :placeholder="$t('findPwd.input_password')">
            <p class="text-error">{{ $t(newPasswordError) }}</p>
          </div>
          <div class="form-row">
            <input class="form-input" type="password" name="password" v-model="pwdAgain" @input="oldPasswordChange()" :placeholder="$t('findPwd.repeat_new_password')" @keyup.enter="saveNewPwd">
            <p class="text-error">{{ $t(re_newPasswordError) }}</p>
          </div>
          <div class="form-row">
            <button class="save-phone-btn" :class="{'disable': passportCode}" @click="saveNewPwd">{{ $t('findPwd.submit_new_password') }}</button>
          </div>
        </div>

        <div v-if="stepSuccess" class="account-form success">
          <div class="form-row">
            <img class="success-img" src="../assets/images/success.png" alt="Success">
          </div>
          <div class="form-row">
            <p class="success_tip">{{ $t("findPwd.success_relogin") }}</p>
          </div>
          <div class="form-row">
            <button class="save-phone-btn" @click="saveStepThree">{{ $t('findPwd.button_relogin') }}</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import * as config from 'common/script/config'
import Validate from 'common/script/validate'
import md5 from 'common/script/md5'
import httpClient from 'common/script/http'

export default {
  name: 'findPwdAccount',
  data () {
    return {
      account: '', // 用户的手机号和邮箱
      imgCode: '', // 图形验证码
      code: '', // 六位数字验证码（发送到手机或邮箱）
      sendBtn: true,
      disabled: false,
      stepAccount: true, // 第一步：验证用户真实性，包括图形验证码
      stepCode: false, // 第二步：验证发送的六位数字验证码
      stepBinding: false, // 第三步：获取手机号绑定账户
      stepSettingNewPwd: false, // 第三步：设置新密码
      stepSuccess: false, // 第四步：显示成功页面
      time: 60,
      timeText: '',
      valueText: 'findPwd.get_code',
      timerFire: '',
      requestId: '',
      imgUrl: '',
      pwd: '', // 新密码
      pwdAgain: '', // 确认新密码
      encryptedAccount: '', // 加 **** 的手机号或邮箱
      secretKey: '',
      way: '',
      accountError: '',
      imgCodeError: '',
      codeError: '',
      newPasswordError: '',
      re_newPasswordError: '',
      tokenCode: '',
      tokenPwd: '',
      phone: '',
      accountList: [],
      disableAccount: true,
      disableStepCode: true,
      passportCode: true,
      otherLanguage: false
    }
  },
  created () {
    this.$initCaptcha()
    window.addEventListener('online', this.sendCode)
    this.requestId = Math.floor(Math.random() * (9999999999 - 1000000000 + 1) + 1000000000) + '' + new Date().getTime()
    this.imgUrl = config.STARRY_HOST + '/common/graphicVerification?requestId=' + this.requestId
    this.otherLanguage = this.$i18n.locale !== 'zh-CN' && this.$i18n.locale !== 'zh-TW'
  },
  methods: {
    accountChange: function () {
      // this.account = this.account.replace(/[^\d]/g, '')
      this.formRequireCheck()
    },
    imgCodeChange: function () {
      this.imgCode = this.imgCode.replace(/\s+/g, '')
      this.formRequireCheck()
    },
    codeChange: function () {
      this.code = this.code.replace(/[^\d]/g, '')
      this.disableStepCode = Validate.stringEmpty(this.code)
    },
    // 忘记密码首页，校验用户名和图形验证码是否为空
    formRequireCheck: function () {
      var validate = false
      if (Validate.stringEmpty(this.account)) {
        validate = true
      }
      if (Validate.stringEmpty(this.imgCode)) {
        validate = true
      }
      if (!Validate.isTel(this.account) && !Validate.validateEmail(this.account)) {
        validate = true
      }
      this.disableAccount = validate
    },
    // 校验用户是否正确和图形验证码正确性
    accountStepOne: function () {
      if (!this.disableAccount) {
        httpClient.postData(config.STARRY_HOST + '/common/checkGraphicVerification', {
          'requestId': this.requestId,
          'phone': this.account,
          'graphicVerification': this.imgCode
        }).then(response => {
          this.reset()
          if (response.code === 1000) {
            this.stepAccount = false
            this.stepCode = true
            this.phone = response.data.phone
            this.encryptedAccount = response.data.phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2')
            this.tokenCode = response.data.token
          } else if (response.code === 2015) {
            if (Validate.isTel(this.account)) {
              this.accountError = 'findPwd.error_userName_2'
            } else {
              this.accountError = 'findPwd.error_userName_3'
            }
          } else if (response.code === 2014) {
            this.imgCodeError = 'findPwd.error_code_3'
          } else if (response.code === 2047) {
            this.imgCodeError = 'findPwd.expired'
            this.findImg()
          }
        })
      }
    },
    // 更换图形验证码
    findImg: function () {
      this.requestId = Math.floor(Math.random() * (9999999999 - 1000000000 + 1) + 1000000000) + '' + new Date().getTime()
      this.imgUrl = config.STARRY_HOST + '/common/graphicVerification?requestId=' + this.requestId
    },
    // 发送六位数字验证码
    sendCode: function () {
      if (navigator.onLine) {
        let lang = 'zh-cn'
        if (this.$i18n.locale !== 'zh-CN' && this.$i18n.locale !== 'ZH-TW') {
          lang = 'en'
        }
        this.$showCaptcha(300, lang, (res) => {
          httpClient.postData(config.STARRY_HOST + '/common/mobileCode', {
            'phone': this.phone,
            'token': this.tokenCode
          }).then((response) => {
            this.reset()
            if (response.code === 1000) {
              this.disabled = true
              this.sendBtn = false
              var itemThis = this
              itemThis.timeText = itemThis.time
              itemThis.valueText = 'findPwd.get_code_tip_re'
              this.timerFire = window.setInterval(function () {
                if (itemThis.time <= 0) {
                  itemThis.time = 60
                  itemThis.timeText = ''
                  itemThis.sendBtn = true
                  itemThis.disabled = false
                  itemThis.valueText = 'findPwd.get_code'
                  window.clearInterval(itemThis.timerFire)
                } else {
                  itemThis.time--
                  itemThis.timeText = itemThis.time
                  itemThis.valueText = 'findPwd.get_code_tip_re'
                }
              }, 1000)
            } else if (response.code === 2019) {
              this.codeError = 'findPwd.error_code_4'
            } else if (response.code === 2018) {
              this.codeError = 'findPwd.error_code_5'
            } else if (response.code === 2016) {
              this.codeError = 'findPwd.error_phone'
            } else if (response.code === 2017) {
              this.codeError = 'findPwd.error_code_2'
            }
          })
        }, (err) => {
          console.log(err)
        })
      }
    },
    // 检验六位数字验证码，并到下一步（获取绑定账号）
    checkCode: function () {
      if (this.disableStepCode) {
        this.codeError = 'findPwd.error_code_1'
      } else {
        httpClient.postData(config.STARRY_HOST + '/account/getAccountList', {
          'phone': this.phone,
          'code': this.code
        }).then((response) => {
          this.reset()
          if (response.code === 1000) {
            this.accountList = response.data.accountList
            this.phone = response.data.phone
            this.tokenPwd = response.data.token
            this.stepBinding = true
            this.stepCode = false
          } else if (response.code === 2014) {
            this.codeError = 'findPwd.error_code_3'
          }
        })
      }
    },
    // 选择账号
    selectAccount: function (accountNo) {
      this.accountNo = accountNo
      this.stepBinding = false
      this.stepSettingNewPwd = true
    },
    newPasswordChange: function () {
      this.pwd = this.pwd.replace(/\s+/g, '')
      this.newPasswordCheck()
    },
    oldPasswordChange: function () {
      this.pwdAgain = this.pwdAgain.replace(/\s+/g, '')
      this.newPasswordCheck()
    },
    // 校验新密码
    newPasswordCheck: function () {
      var validate = false
      if (Validate.stringEmpty(this.pwd)) {
        // this.newPasswordError = 'findPwd.input_password'
        validate = true
      }
      if (Validate.stringEmpty(this.pwdAgain)) {
        // this.re_newPasswordError = 'findPwd.repeat_new_password'
        validate = true
      }
      // if (validate) {
      //   if (!Validate.passwordRule(this.pwdAgain)) {
      //     this.re_newPasswordError = 'findPwd.password_set'
      //     validate = true
      //   }
      // }
      this.passportCode = validate
    },
    // 设置新密码
    saveNewPwd: function () {
      if (!this.passportCode) {
        if (!Validate.passwordRule(this.pwd) || !Validate.passwordOK(this.pwd)) {
          this.re_newPasswordError = 'findPwd.password_set'
          return
        }
        if (!Validate.passwordOK(this.pwd)) {
          this.re_newPasswordError = ''
        }
        this.reset()
        if (this.pwd === this.pwdAgain) {
          httpClient.postData(config.STARRY_HOST + '/account/updatePassword', {
            'accountNo': this.accountNo,
            'password': md5.hex_md5(this.pwdAgain),
            'phone': this.phone,
            'token': this.tokenPwd
          }).then((response) => {
            if (response.code === 1000) {
              this.stepSuccess = true
              this.stepSettingNewPwd = false
            } else if (response.code === 1002) {
              this.re_newPasswordError = '令牌失效'
            }
          })
        } else if (this.pwd !== this.pwdAgain) {
          this.re_newPasswordError = 'findPwd.new_password_error'
        }
      }
    },
    // 最后一步跳转登录页面
    saveStepThree: function () {
      this.$router.push('Login')
    },
    // reset form
    reset: function () {
      this.accountError = ''
      this.imgCodeError = ''
      this.codeError = ''
      this.newPasswordError = ''
      this.re_newPasswordError = ''
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  $bottom_footer_height = 56px
  body,html
    height 100%
  .body-container
    display block
    position relative
    height 100%
    padding-bottom $bottom_footer_height
    box-sizing border-box
    font-size 12px
    min-height 695px
    background-color #fafafa
    .body-content
      position relative
      height 100%
      min-height 600px
      .account-wrapper
        position absolute
        padding-top 10px
        left 50%
        top 50%
        box-sizing border-box
        background-color #ffffff
        overflow hidden
        width 600px
        height 500px
        margin-left -300px
        margin-top -250px
        .success
          width 100%
          text-align center
          .form-row
            .success-img
              height 50px
            p
              font-size 15px
              margin-top 300px
              margin-bottom 300px
        .account-form
          padding-top 40px
          display block
          width 310px
          position relative
          margin 0 auto
          font-size 14px
          &.success
            width 100%
            .form-row
              text-align center
              .success-img
                height 50px
              .success_tip
                font-size 15px
                margin-top 30px
                margin-bottom 30px
          &.binding-form
            width 100%
            padding-top 60px
            .binding-content
              width 485px
              height 220px
              overflow-y auto
              margin 0 auto
              &.lang
                width 500px
              .binding-item
                width 450px
                position relative
                margin-bottom 30px
                line-height 30px
                color #3d3d3d
                font-size 18px
                text-align left
                &.lang
                  width 500px
                span
                  font-weight 500
                &:last-child
                  margin-bottom 0
                .binding-icon
                  width 20px
                  vertical-align middle
                .account-text
                  margin 0 15px 0 30px
                .binding-button
                  width 100px
                  height 30px
                  line-height 30px
                  text-align center
                  color #272f44
                  font-size 15px
                  border 1px solid #272f44
                  border-radius 3px
                  box-sizing border-box
                  position absolute
                  top 0
                  right 0
                  cursor pointer
                  &.lang
                    width 150px
          .form-row
            text-align left
            display block
            margin 0
            .save-phone-btn
              &.disable
                background-color #dadada
                cursor default
            .form-input
              width 310px
              display inline-block
              font-size 14px
              -webkit-appearance none
              background #f6f6f6
              border-radius 4px
              outline none
              height: auto
              padding: 14px
              box-sizing: border-box
              text-align center
              &.input-require
                border-color #f6a94c
              input
                height auto
                padding 14px
                box-sizing border-box
            .text-error
              min-height 20px
            .code-input
              width 186px
            .send-code-btn, .sendBtn
              float right
              margin-top 5px
              min-width 100px
              height 35px
              line-height 35px
              font-size 12px
              cursor pointer
            .disabled
              float right
              margin-top 5px
              min-width 100px
              height 35px
              line-height 35px
              font-size 12px
              cursor auto
              background-color #a9acb4
          button
            color #fff
            background #272f44
            display inline-block
            font-size 15px
            height 45px
            line-height 45px
            text-align center
            min-width 310px
            cursor pointer
            border-radius 4px
            outline none
            border none
          .code-row
            margin-top 20px
      .text-error
        display block
        padding-top 6px
        font-size 12px
        text-align left
        color #f6a94c
      .slogan-wrapper
        //margin-top 36px
        text-align center
        .icon-starry-meeting
          text-align left
          display block
          margin-left 10px
          font-size 20px
        img
          width 55px
          height 55px
        .slogan-text
          display block
          margin-top 68px
          color #272f44
          font-size 36px
        .slogan-text-small
          color #272f44
          display block
          font-size 12px
          margin-top 10px
</style>



// WEBPACK FOOTER //
// src/components/findPwdAccount.vue